import _extends from "@babel/runtime/helpers/extends";
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/ListItem/ListItem.js",
  _this = this;
import React, { isValidElement } from 'react';
import { Completed as CompletedIcon, Alert as AlertIcon } from '@dls/assets/icons';
import Card from '../Card';
import { Box, Column, Columns, LeftContainer, RightContainer, ListItemImage, ListItemThumbnail, SubTitle, TagWrapper, Tag, Title, ListItemPointsContainer } from './style';
import { createLegoComponent, getLegoElementName } from '../../core/utils/legoUtils';
import { getFilteredList } from '../../core/utils/getFilteredList';
import { testIdProps } from '../../helpers';
import { resizeIcon } from '../../helpers/utils';
import Toggle from '../Toggle';
import { useTheme, ThemeProvider } from '../../core/ThemeProvider';
var STATUS_TYPES = {
  success: {
    Icon: CompletedIcon,
    color: 'cl_successGreen'
  },
  error: {
    Icon: AlertIcon,
    color: 'cl_errorRed'
  }
};
var ListItem = function ListItem(p) {
  var dataTestId = p.dataTestId,
    onClick = p.onClick,
    leftContent = p.leftContent,
    body = p.body,
    rightContent = p.rightContent,
    bordered = p.bordered,
    maxTitleLine = p.maxTitleLine,
    maxSubtitleLine = p.maxSubtitleLine;
  var isListItemTall = getLegoElementName(leftContent) === 'ListItemThumbnail';
  var tagContent = isListItemTall ? getFilteredList(body, 'tag')[0] : null;
  var isBordered = isListItemTall || bordered;
  var renderTag = function renderTag() {
    if (tagContent) {
      return /*#__PURE__*/isValidElement(tagContent.tag) ? /*#__PURE__*/React.createElement(TagWrapper, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 57,
          columnNumber: 9
        }
      }, tagContent.tag) : /*#__PURE__*/React.createElement(Tag, {
        key: tagContent.tag,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 59,
          columnNumber: 9
        }
      }, tagContent.tag);
    }
    return null;
  };
  var renderChild = function renderChild() {
    return /*#__PURE__*/React.createElement(Columns, {
      tall: isListItemTall,
      onClick: onClick,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 67,
        columnNumber: 7
      }
    }, leftContent && /*#__PURE__*/React.createElement(Column, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(LeftContainer, {
      bordered: isBordered,
      tall: isListItemTall,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 71,
        columnNumber: 13
      }
    }, leftContent, renderTag())), /*#__PURE__*/React.createElement(Column, {
      width: "content",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 79,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(Box, {
      bordered: isBordered,
      isFirst: !leftContent,
      isLast: !rightContent,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 80,
        columnNumber: 11
      }
    }, body && renderBody(body, isListItemTall, {
      maxTitleLine: maxTitleLine,
      maxSubtitleLine: maxSubtitleLine
    }))), /*#__PURE__*/React.createElement(Column, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 94,
        columnNumber: 9
      }
    }, renderRightContent(rightContent, {
      bordered: isBordered
    })));
  };
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: {
      button: {
        minWidth: 'fit-content'
      }
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 102,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", _extends({}, testIdProps(p, dataTestId), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 7
    }
  }), isBordered ? /*#__PURE__*/React.createElement(Card, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 23
    }
  }, renderChild()) : renderChild()));
};
ListItem.defaultProps = {
  dataTestId: 'list-item',
  leftContent: null,
  rightContent: null,
  bordered: true,
  maxTitleLine: 1,
  maxSubtitleLine: 1
};
var ListItemIcon = createLegoComponent('ListItemIcon', function (_ref) {
  var Icon = _ref.icon;
  return resizeIcon(Icon);
});
var ListItemStatus = createLegoComponent('ListItemStatus', function (p) {
  var status = STATUS_TYPES[p.type];
  if (!status) return null;
  var _useTheme = useTheme(),
    theme = _useTheme.theme;
  var Icon = status.Icon,
    color = status.color;
  return /*#__PURE__*/React.createElement(Icon, {
    color: theme[color],
    size: 24,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 173,
      columnNumber: 10
    }
  });
});
var ListItemToggle = createLegoComponent('ListItemToggle', Toggle);
var ListItemPoints = createLegoComponent('ListItemPoints', function (p) {
  var text = p.text,
    Icon = p.icon;
  var _useTheme2 = useTheme(),
    theme = _useTheme2.theme;
  return /*#__PURE__*/React.createElement(ListItemPointsContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 182,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    size: theme.listItem.sizeIcon,
    color: theme.listItem.colorIcon,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 183,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("span", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 184,
      columnNumber: 7
    }
  }, text));
});
ListItem.Icon = ListItemIcon;
ListItem.Image = ListItemImage;
ListItem.Thumbnail = ListItemThumbnail;
ListItem.Toggle = ListItemToggle;
ListItem.Status = ListItemStatus;
ListItem.Points = ListItemPoints;
export default ListItem;
/**
 * Render main body content
 * @param bodyProps
 * @param bodyProps.title
 * @param bodyProps.subTitle
 * @param bodyProps.tag
 * @param bodyProps.points
 * @return {any[]}
 */

function renderBody() {
  var _this2 = this;
  var bodyProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var isListItemTall = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var option = arguments.length > 2 ? arguments[2] : undefined;
  var newBodyProps = isListItemTall ? bodyProps : getFilteredList(bodyProps, ['points', 'tag'], true);
  return newBodyProps.map(function (_ref2, index) {
    var title = _ref2.title,
      subTitle = _ref2.subTitle,
      points = _ref2.points;
    if (title) return /*#__PURE__*/React.createElement(Title, {
      key: title + index,
      maxLine: option.maxTitleLine,
      __self: _this2,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 215,
        columnNumber: 9
      }
    }, title);
    if (subTitle) return /*#__PURE__*/React.createElement(SubTitle, {
      key: subTitle + index,
      maxLine: option.maxSubtitleLine,
      __self: _this2,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 222,
        columnNumber: 9
      }
    }, subTitle);
    if (points) return /*#__PURE__*/React.createElement("div", {
      key: index,
      __self: _this2,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 227,
        columnNumber: 24
      }
    }, points);
  });
}
function renderRightContent(content, option) {
  var _content$props;
  var legoElName = getLegoElementName(content);
  var hasOnClick = !!(content !== null && content !== void 0 && (_content$props = content.props) !== null && _content$props !== void 0 && _content$props.onClick);
  if (legoElName) {
    return /*#__PURE__*/React.createElement(RightContainer, {
      bordered: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 236,
        columnNumber: 12
      }
    }, content);
  }
  /**
   * Content is not a ListItem lego block.
   * render as is.
   * */

  return /*#__PURE__*/React.createElement(RightContainer, _extends({
    onClick: hasOnClick ? function (e) {
      return e.stopPropagation();
    } : null
  }, option, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 243,
      columnNumber: 5
    }
  }), content);
}